module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("2iYtW"))).then(() => parcelRequire('d0iPb'));